/**
 * Custom toast system that doesn't conflict with Nuxt UI
 * 
 * NOTE: For most use cases, please use the official Nuxt UI toast system:
 * import { useToast } from '#imports'
 */
import { ref } from 'vue'

interface Toast {
  id: number
  title: string
  description?: string
  duration: number
  type: 'default' | 'success' | 'error' | 'warning' | 'info'
  visible: boolean
}

const toasts = ref<Toast[]>([])

export function useCustomToast() {
  const addToast = (title: string, type: Toast['type'] = 'info', duration: number = 5000) => {
    const id = Math.floor(Math.random() * 1000000)
    toasts.value.push({ id, title, type, duration, visible: true })
    
    if (duration > 0) {
      setTimeout(() => {
        removeToast(id)
      }, duration)
    }
  }

  const removeToast = (id: number) => {
    toasts.value = toasts.value.filter(toast => toast.id !== id)
  }

  return {
    toasts,
    addToast,
    removeToast
  }
} 